import { render, staticRenderFns } from "./CategoriaRepresentiva.vue?vue&type=template&id=4fa2da74&scoped=true&"
import script from "./CategoriaRepresentiva.vue?vue&type=script&lang=js&"
export * from "./CategoriaRepresentiva.vue?vue&type=script&lang=js&"
import style0 from "./CategoriaRepresentiva.vue?vue&type=style&index=0&id=4fa2da74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa2da74",
  null
  
)

export default component.exports